/**
 * Basis-URL des Express-Servers in server/ (Stripe-Checkout, Gutscheine, Kontolöschung,
 * QM-Assistent). Genau eine Stelle, die die Umgebungsvariable liest.
 *
 * `VITE_SERVER_URL` ist der neue Name. `REACT_APP_SERVER_URL` bleibt als Rückfall, bis die
 * Variable bei Vercel und in den lokalen .env-Dateien umbenannt ist; danach kann der
 * Rückfall samt `REACT_APP_` in envPrefix (vite.config.ts) weg.
 */
export const SERVER_URL: string =
  import.meta.env.VITE_SERVER_URL || import.meta.env.REACT_APP_SERVER_URL || 'http://localhost:4242'
